import { useEffect, useState } from 'react';
import { BadgeIndianRupee, ReceiptText } from 'lucide-react';
import { Link } from 'react-router-dom';
import { loadMyTransactions } from '../lib/subscribe';
import type { TransactionRow } from '../lib/subscribe';
import { Button, EmptyState, LoadingState } from '../components/ui';
import { TransactionList } from './StudentSubscribe';

export function StudentTransactions() {
  const [rows, setRows] = useState<TransactionRow[]>();
  useEffect(() => {
    let active = true;
    void loadMyTransactions().then((next) => { if (active) setRows(next); }).catch(() => { if (active) setRows([]); });
    return () => { active = false; };
  }, []);

  return <div className="utility-page">
    <section className="utility-hero"><div className="utility-icon"><ReceiptText size={28} /></div><div><h1>Transactions</h1><p>Your subscription payments, read-only history</p></div></section>
    {!rows ? <LoadingState /> : rows.length
      ? <TransactionList rows={rows} />
      : <EmptyState icon={BadgeIndianRupee} title="No transactions yet" description="Payments recorded by the AyurGuide team will appear here." action={<Link to="/subscribe"><Button variant="soft">View plans</Button></Link>} />}
  </div>;
}
